import { render, staticRenderFns } from "./TomHornFreespinsAddForm.vue?vue&type=template&id=14856c90&"
import script from "./TomHornFreespinsAddForm.vue?vue&type=script&lang=js&"
export * from "./TomHornFreespinsAddForm.vue?vue&type=script&lang=js&"
import style0 from "./TomHornFreespinsAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports